<template>
  <div
    v-if="singleImageTextAd"
    :class="['singleimage-textad-container', globalClassAttributes]"
    :style="styleAttributes"
  >
    <div class="image-container">
      <ImageMap
        class="text-image"
        :image-map="getImage(singleImageTextAd)"
      />
    </div>
    <TextAd
      :text="singleImageTextAd"
      :text-array="contentOrder"
      :apply-global-styles="false"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import TextAd from './TextAd';
import ImageMap from '../imageMap';
import { getClassAttributes, getStyleAttributes } from '../../helpers/getAttributes';
import getImage from '../../helpers/getImage';

const props = defineProps({
  singleImageTextAd: {
    type: Object,
    default: () => {},
  },
  contentOrder: {
    type: Array,
    default: () => [
      'heading',
      'body',
      'subHeading',
      'subBody',
    ],
  },
});

const globalClassAttributes = getClassAttributes(props.singleImageTextAd?.attributes);
// set styleAttributes onMounted to prevent background-color being applied to skeleton loader
const styleAttributes = ref({});
onMounted(() => {
  if (props.singleImageTextAd?.attributes) {
    styleAttributes.value = getStyleAttributes(props.singleImageTextAd.attributes);
  }
});
</script>

<style lang="scss" scoped>
.image-container{
  overflow: hidden;
}

.singleimage-textad-container :deep(.textad-wrapper){
  padding: 0;
}

 #canvas {
    .media-component-singleImageTextAd {
      .grid-x .cell.full-width {
        .singleimage-textad-container{
        @include breakpoint(small only){
          padding-right: rem-calc(20px);
          padding-left: rem-calc(20px);
        }
      }
     }
   }
 }

</style>

<style lang="scss" brand="mcom" scoped>
@import "./../../scss/globalAttributes.mcom.scss";
:deep(){
  .textad-container {
    .body {
      margin-top: rem-calc(8);
    }
  }
}

.text-image:not(.video) {

  &:hover{
    transform :scale(1.1);
    transition: transform .2s;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
@import "./../../scss/globalAttributes.bcom.scss";

:deep(){
  .textad-container {
    .body {
      margin-top: rem-calc(4);
    }
    .subHeading {
      margin-top: rem-calc(16);
    }
    .subBody {
      margin-top: rem-calc(4);
    }
    .eyebrow {
      margin-top: rem-calc(16);
    }
  }
}

</style>
